/**
 * Created by Simon Zhao on 7/22/21
 * Description: the configuration of each template field.
 *
 * ------ maintenance history ------
 */

export class TemplateField {
    componentType: string;
    controlID: string;
    label: string;
}
